/**
 * How often an open inbox looks for new messages and delivery results when
 * Realtime is not delivering them. TanStack Query skips it while the tab is
 * hidden (refetchIntervalInBackground is off).
 */
export const INBOX_POLL_MS = 30_000;
